import { AbstractTextEditor } from '../../../../../../vscode/src/vs/workbench/browser/parts/editor/textEditor.js';
export { TextEditorPaneSelection } from '../../../../../../vscode/src/vs/workbench/browser/parts/editor/textEditor.js';
import { setAbstractTextEditor } from './textEditor.weak.js';
setAbstractTextEditor(AbstractTextEditor);
export { AbstractTextEditor };
